import { browser } from "@workspace/mobile";

/**
 * Checks whether a URL is an external link (absolute HTTP/HTTPS URL).
 */
export const isExternalUrl = (url: string): boolean => {
  const trimmed = url.trim();
  return trimmed.startsWith("http://") || trimmed.startsWith("https://");
};

/**
 * Opens an external link in the device's default browser when running
 * inside the native webview wrapper, or in a new browser tab when
 * running on the web.
 *
 * This prevents external URLs from loading inside the native webview
 * where there is no navigation mechanism to return to the app.
 */
export const openExternalLink = (url: string): void => {
  if (!url) return;

  const isNativeApp =
    typeof window !== "undefined" && "ReactNativeWebView" in window;

  if (isNativeApp) {
    browser.open(url, "external");
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
